// Types
import {
  PublishMode,
  TicketEventFormValues,
  VenueMode,
} from 'pages/Events/components/TicketEventForm/types';
// Helpers
import { DEFAULT_MAX_PER_ORDER } from 'pages/Events/components/TicketEventForm/helpers';

export const getCreateFormValues = (
  hostId?: string
): TicketEventFormValues => ({
  hostId,
  streamId: null,
  hashtags: [],
  venueMode: VenueMode.New,
  ticketsEnabled: true,
  tiers: [{ maxPerOrder: DEFAULT_MAX_PER_ORDER }],
  sportIds: [],
  affiliateEnabled: false,
  fanPollingEnabled: false,
  publishMode: PublishMode.Draft,
  approveZeroTax: false,
  bouts: [],
});
